export default {"src":"/_next/static/media/fUsdt.84e107fb.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};